import { ListViewControl } from "../../api/ControlGroup";
import { KeyValue } from "../../reports/utils";

type filterKeys =
  | "company_uuid"
  | "behavior_kit_uuid"
  | "blueprint_uuid"
  | "full_name"
  | "client_report_id"
  | "report_uuid";

/** Partial filter data: keys may be string[] or KeyValue[], used for display labels. Accepts FilterOptions from API or partial objects like { company_uuid: KeyValue[] }. */
export type FilterDataLike = Record<string, (string | KeyValue)[] | undefined>;

export function getFilterValues(
  controlGroups: ListViewControl[],
  filterKey: filterKeys,
  filterData: FilterDataLike | undefined
) {
  const groupKeys = controlGroups.find((group) => group.name === filterKey);
  const items = (filterData?.[filterKey as keyof typeof filterData] ?? []) as (
    | string
    | KeyValue
  )[];
  const filterValues = items
    .filter((data: KeyValue | string) => {
      const dataKey = typeof data === "string" ? data : data.key;
      return groupKeys?.controls.filters.includes(dataKey);
    })
    .map((data: KeyValue | string) => {
      const dataKey = typeof data === "string" ? data : data.value;
      return dataKey;
    });

  return filterValues;
}

export function hasFilterValues(
  controlGroups: ListViewControl[],
  filterKey: filterKeys
) {
  const group = controlGroups.find((group) => group.name === filterKey);
  return (
    controlGroups.length !== 0 &&
    (group ? group.controls.filters.length > 0 : false)
  );
}
